export const NZ_REGIONS = [
  { code: "AUK", name: "Auckland", slug: "auckland" },
  { code: "BOP", name: "Bay of Plenty", slug: "bay-of-plenty" },
  { code: "CAN", name: "Canterbury", slug: "canterbury" },
  { code: "GIS", name: "Gisborne", slug: "gisborne" },
  { code: "HKB", name: "Hawke's Bay", slug: "hawkes-bay" },
  { code: "MWT", name: "Manawatū-Whanganui", slug: "manawatu-whanganui" },
  { code: "MBH", name: "Marlborough", slug: "marlborough" },
  { code: "NSN", name: "Nelson", slug: "nelson" },
  { code: "NTL", name: "Northland", slug: "northland" },
  { code: "OTA", name: "Otago", slug: "otago" },
  { code: "STL", name: "Southland", slug: "southland" },
  { code: "TKI", name: "Taranaki", slug: "taranaki" },
  { code: "TAS", name: "Tasman", slug: "tasman" },
  { code: "WKO", name: "Waikato", slug: "waikato" },
  { code: "WGN", name: "Wellington", slug: "wellington" },
  { code: "WTC", name: "West Coast", slug: "west-coast" },
] as const;

export type NzRegionCode = (typeof NZ_REGIONS)[number]["code"];
